export enum RideType {
  ROUND_TRIP = "RoundTrip",
  ONE_WAY = "OneWay",
}
